export const Card = () => {
  return (
    <svg className="dashboard__image" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
      <path d="M30,17.6c-10.3,0-18.6,8.3-18.6,18.6S19.7,54.8,30,54.8s18.6-8.3,18.6-18.6S40.3,17.6,30,17.6z M30,52.8
        c-9.2,0-16.6-7.5-16.6-16.6S20.8,19.6,30,19.6S46.6,27,46.6,36.2S39.2,52.8,30,52.8z"/>
      <path d="M29.6,13.5c3.4,0,6.1-1.9,6.1-4.3S33,5,29.6,5c-3.4,0-6.1,1.9-6.1,4.3S26.2,13.5,29.6,13.5z M29.6,7c2.3,0,4.1,1.2,4.1,2.3
        c0,1.1-1.8,2.3-4.1,2.3c-2.3,0-4.1-1.2-4.1-2.3C25.5,8.2,27.3,7,29.6,7z"/>
      <path d="M30,0C16.6,0,5.7,19.9,5.7,36c0,14.9,10.8,24,24.2,24c13.4,0,24.3-9,24.3-23.8C54.2,21.3,43.3,0,30,0z M30,58
        C16.9,58,7.7,49,7.7,36c0-10.2,4.6-22,11.3-28.7C22.5,3.8,26.3,2,30,2c11.5,0,22.3,19.3,22.3,34.2C52.2,49,43.1,58,30,58z"/>
    </svg>
  );
};
